module.exports = __webpack_public_path__ + "img/822004747.541397c5.png";